"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapValue = void 0;
/* eslint-disable import/prefer-default-export */
var getMapValue = function (map, key) { return map.get(key) || ''; };
exports.getMapValue = getMapValue;
